import React, { useState } from 'react';
import {
    Tab,
    TabList,
    SelectTabData,
    SelectTabEvent,
    makeStyles,
} from '@fluentui/react-components';

export interface TabDefinition {
    value: string;
    label: string;
    content: React.ReactNode;
}

export interface TabbedDrawerContentProps {
    tabs: TabDefinition[];
    defaultTab?: string;
}

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    },
    tabList: {
        padding: '16px 16px 0 16px',
    },
    tabContent: {
        flex: 1,
        overflow: 'auto',
        minHeight: 0,
    },
});

const TabbedDrawerContent: React.FC<TabbedDrawerContentProps> = ({
    tabs,
    defaultTab,
}) => {
    const classes = useStyles();
    const [selectedTab, setSelectedTab] = useState(
        defaultTab || (tabs.length > 0 ? tabs[0].value : '')
    );

    const onTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
        setSelectedTab(data.value as string);
    };

    const activeTab = tabs.find((t) => t.value === selectedTab);

    return (
        <div className={classes.container}>
            <TabList
                selectedValue={selectedTab}
                onTabSelect={onTabSelect}
                className={classes.tabList}
            >
                {tabs.map((tab) => (
                    <Tab key={tab.value} value={tab.value}>
                        {tab.label}
                    </Tab>
                ))}
            </TabList>
            <div className={classes.tabContent}>
                {activeTab?.content}
            </div>
        </div>
    );
};

export default TabbedDrawerContent;
